import { GridColDef } from "@mui/x-data-grid";
import { TFunction } from "i18next";
import { DateTime } from "luxon";
import { TbClock } from "react-icons/tb";

import { TableHeader } from "@/components/TableHeader";
import { User } from "@/types/user.types";

function RenderCell({ value }: { value: string | null }) {
    const updatedAt = (value && DateTime.fromISO(value).toFormat("dd.MM.yyyy HH:mm")) || "";
    return <div className="flex items-center py-1 pl-2 h-full">{updatedAt}</div>;
}

export const UserUpdatedAtColumn = ({ t }: { t: TFunction }): GridColDef<User> => {
    return {
        field: "updatedAt",
        headerName: t("updatedAt"),
        minWidth: 160,
        valueGetter: (_val, row) => row.updatedAt,
        renderHeader: (params) => <TableHeader Component={TbClock} title={params.colDef.headerName!} />,
        renderCell: ({ value }) => <RenderCell value={value} />,
    };
};
export default UserUpdatedAtColumn;
